module.exports = __webpack_public_path__ + "img/china.67087576.png";